import React from 'react';

const Question = (props) => {
    let {
        currentSituation,
        currentQuestion,
        currentValue,
        labels,
        situationTimesShown,
        maxTimesToShowSituationReading,
        maxTimesToShowSituationHearing,
        lastQuestion,
        verifyIfReadingOrHearing,
        verifyIfHearing,
        verifyIfReading,
        answerChange,
        requestSendAnswer,
        showSituationReading,
        showSituationHearing,
        getAudioForSituation,
        loadingNextQuestion
    } = props;

    return(
        <div className="m-portlet m-portlet--primary m-portlet--head-solid-bg mb-0">
            <div className="m-portlet__head">
                <div className="m-portlet__head-caption">
                    <div className="m-portlet__head-title">
                        <h3 className="m-portlet__head-text">{ currentQuestion.question }</h3>
                    </div>
                </div>
            </div>
            <div className="m-portlet__body m-form__group form-group m-radio-list mb-0">
                { currentQuestion.show_image == true &&
                    <div className="row">
                        <div className="col-md-12 mb-5">
                            <img src={`data:image/jpeg;base64,${currentQuestion.image_question}`}
                                 className="img-thumbnail img-answer"/>
                        </div>
                    </div>
                }
                { currentQuestion.answers.map((answer, i) =>
                    <label key={ i } className="m-radio m-radio--bold">
                        <input type="radio" name={ currentQuestion.question_id }
                               checked={currentValue === answer.answer_id}
                               onChange={answerChange} value={ answer.answer_id }/>
                        { answer.show_image == true &&
                            <img src={`data:image/jpeg;base64,${answer.image_answer}`}
                                 className="img-thumbnail img-question mr-3" />
                        }
                        <span style={ {top: answer.show_image && '66px' } }></span>
                        { answer.answer }
                    </label>)}
            </div>
            <div className="m-portlet__foot">
                <button className="btn m-btn--square btn-primary mr-5"
                        disabled={currentValue === 0 || loadingNextQuestion === true}
                        onClick={requestSendAnswer}>
                    { <span className={loadingNextQuestion ? undefined : 'd-none'}>
                        <i className="fas fa-spinner fa-pulse"></i> </span> }
                    { lastQuestion === false && labels.Siguiente }
                    { lastQuestion === true && labels.Terminar }
                </button>

                {/* Verifica si puede volver a ver la situación si es de lectura o audio */}
                { verifyIfReading(currentSituation.TipoSituacion) &&
                    <button className="btn m-btn--square btn-info"
                            disabled={situationTimesShown >= (verifyIfHearing(currentSituation.TipoSituacion) ? maxTimesToShowSituationHearing : maxTimesToShowSituationReading)}
                            onClick={verifyIfHearing(currentSituation.TipoSituacion) ? showSituationHearing : showSituationReading}>
                        { currentSituation.TipoSituacion == 1 && labels.Leer }
                        { currentSituation.TipoSituacion == 2 && labels.Escuchar }
                    </button>
                }
                { verifyIfHearing(currentSituation.TipoSituacion) &&
                    <audio className='m--hide' autobuffer="autobuffer" controls="controls" id="audio_player"
                           src={`data:audio/mp3;base64,${getAudioForSituation()}`}>
                    </audio>
                }
            </div>
        </div>
    );
};

export default Question;
